import Proj1 from "../../assets/Project-images/pp1.PNG";
import Proj2 from "../../assets/Project-images/pp2.PNG";
import Proj3 from "../../assets/Project-images/pp3.PNG";
import Proj4 from "../../assets/Project-images/pp4.PNG";
import Proj5 from "../../assets/Project-images/pp5.PNG";
import Proj6 from "../../assets/Project-images/pp6.PNG";
import Proj7 from "../../assets/Project-images/pp7.PNG";
import Proj8 from "../../assets/Project-images/pp8.PNG";
import Proj9 from "../../assets/Project-images/pp9.PNG";

export const ProjectList = [
    {
        name: "Electro-Depot",
        image1: Proj1,
        image2: Proj2,
        image3: Proj3,
        skills: "React.js, react-router, react-Bootstrap, react-hook-form, react-toastify, Rechart, Google map, Firebase-Authenticati.",
        shortDes: "Warehouse management system (Full-Stack)",
        gitLink: "https://github.com/TEMPLAR-007/Electro-Depot",
        LiveLink: "https://electro-depot-cc605.web.app/",
        features: [
            " This website contains some data management system, you can view your product and edit/delete them on purpose.",
            " Users can also see their own added product. Overall you have a minimalist dashboard in this website.",
            " Implemented Firebase-Authentication for verify user’s and Sign-up/Login."
        ]
    },
    {
        name: "PC-Constructor",
        image1: Proj4,
        image2: Proj5,
        image3: Proj6,
        skills: "React.js, react-router, react-toastify, Tailwind CSS, Firebas-Authentication, Node.js, MongoDB, Stripe.",
        shortDes: "Tool Manufacturer website (Full-Stack)",
        LiveLink: "https://pc-constructor-7114a.web.app/",
        gitLink: "https://github.com/TEMPLAR-007/PC-Constructor",
        features: [
            "This website contains some data management system, you can view your product and edit/delete them on purpose.",
            " Users can also see their own added product. Overall you have a minimalist dashboard in this website.",
            " Implemented Firebase-Authentication for verify user’s and Sign-up/Login."
        ]
    },
    {
        name: "Springo-Photography",
        image1: Proj7,
        image2: Proj8,
        image3: Proj9,
        skills: "React.js, react-router, react-Bootstrap, Firebase-Authentication.",
        shortDes: "Single Service Provider Website",
        gitLink: "https://github.com/TEMPLAR-007/Springo-Photography",
        LiveLink: "https://springo-photography.web.app/",
        features: [
            "This website contains some data management system, you can view your product and edit/delete them on purpose.",
            " Users can also see their own added product. Overall you have a minimalist dashboard in this website.",
            " Implemented Firebase-Authentication for verify user’s and Sign-up/Login."
        ]
    }
];